module.exports = __webpack_public_path__ + "static/media/acura-checkmark.c6f29a0d.svg";